import { StyledMetaverseSection } from './MetaverseSection.styled';
import { useState } from 'react';
import MetaverseSectionItem from './MetaverseSectionItem';
import useIsMobile from '../../hooks/useIsMobile';

const ITEM_WIDTH = [
  '100%',
  '100%',
  '45%',
  '30%',
  '22%',
  '18%'
]
const MetaverseSectionPage = ({ items, pageSize = 3 }) => {
  const pageItems = [...items];
  while (pageItems.length < pageSize) {
    pageItems.push(null);
  }
  return (
    <div className='metaverse-section-page'>
      {items.map((i) => (<MetaverseSectionItem width={ITEM_WIDTH[pageSize]} item={i}/>))}
    </div>
  );
};

const MetaverseSectionTitleButton = ({ onClick, disabled = false, backward = false }) => {
  return (
    <div className='metaverse-section-title-button' onClick={() => disabled ? false : onClick()} style={{cursor: 'pointer'}}>
      <div className='metaverse-section-title-button-content'>
        <img src='/assets/arrow_right.svg' style={{ opacity: disabled ? '0.4' : '1.0', rotate: backward ? '180deg' : '0deg' }}/>
      </div>
      <div className='metaverse-section-title-button-corner metaverse-section-title-button-corner-l' />
      <div className='metaverse-section-title-button-corner metaverse-section-title-button-corner-r' />
    </div>
  );
};

const MetaverseSection = ({ title, items = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const isMobile = useIsMobile();
  const groupSize = isMobile ? 2 : 3;
  const itemGroups = items.reduce(function(result, value, index, array) {
    if (index % groupSize === 0)
      result.push(array.slice(index, index + groupSize));
    return result;
  }, []);

  while (itemGroups[itemGroups.length - 1].length < groupSize) {
    itemGroups[itemGroups.length - 1].push(null);
  }

  const onClickRight = () => {
    setCurrentIndex(currentIndex + 1);
  };

  const onClickLeft = () => {
    setCurrentIndex(currentIndex - 1);
  };

  const rightDisabled = currentIndex >= itemGroups.length - 1;
  const leftDisabled = currentIndex < 1;

  while (items.length % groupSize !== 0) {
    items.push(null);
  } 
  return (
    <StyledMetaverseSection $group={groupSize}>
      <div className='metaverse-section-title-holder'>
	<div className='metaverse-section-title-stub-short' />
        <div className='metaverse-section-title'>{title}</div>
	<div className='metaverse-section-title-stub-long' />
	{/*!isMobile && <div className='metaverse-section-title-controls'>
          <MetaverseSectionTitleButton disabled={leftDisabled} onClick={onClickLeft} backward={true} />
          <MetaverseSectionTitleButton disabled={rightDisabled} onClick={onClickRight}/>
        </div>}
        {!isMobile && <div className='metaverse-section-title-stub-short' />*/}
      </div>
      {/*<div className='metaverse-section-carousel-wrapper'>
        <AppCarousel currentIndex={currentIndex}>
          {itemGroups.map((g) => (<MetaverseSectionPage items={g} pageSize={groupSize} />))}
        </AppCarousel>
      </div>*/}
      <div className='metaverse-section-items'>
        {items.map((i) => (<MetaverseSectionItem width={ITEM_WIDTH[groupSize]} item={i}/>))}
      </div>
    </StyledMetaverseSection>
  );
};

export default MetaverseSection;
